import React, { ReactElement, ReactNode, useState, useEffect } from 'react';
import { Blankslate } from '@primer/react/experimental';
import { AlertIcon } from '@primer/octicons-react'

interface BlankslateProps {
    icon: ReactElement;
    header?: string;
    description?: string;
    button: ReactNode;
    className?: string
    isModal?: boolean;
}
const Placeholder: React.FC<BlankslateProps> = ({ icon, header, description, button, className = "", isModal = false }) => {
    return (
        <div style={isModal ? undefined : {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%'
        }}>
            <Blankslate className={`flex flex-col items-center text-center ${className}`}>
                <Blankslate.Visual>
                    {icon}
                </Blankslate.Visual>
                <div className='mt-4'>
                    <Blankslate.Heading>{header}</Blankslate.Heading>
                    <Blankslate.Description>
                        <span className='whitespace-pre-line'>{description}</span>
                    </Blankslate.Description>
                </div>
                <Blankslate.SecondaryAction href='#'>
                    {button}
                </Blankslate.SecondaryAction>
            </Blankslate>
        </div>
    );
};
export const createErrorPlaceholder = (): ReactElement => {
    return <DelayedErrorPlaceholder />;
};

const DelayedErrorPlaceholder = (): ReactElement | null => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true);
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    if (!show) return null;

    const icon = <AlertIcon size={32} />;
    const header = "Ошибка";
    const description = "Не удается выполнить запрос, \nпопробуйте позже";
    return <Placeholder icon={icon} header={header} description={description} button={undefined} />;
};

export default Placeholder;